import { Component, OnInit } from '@angular/core';
import { ContactUsService } from './contact-us.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {
  contactUs = {
    name : '',
    email: '',
    subject: '',
    message: '',
    file: File
  }
  showEmptyFieldsError: boolean;
  contactMessage: string;

  constructor(private contactUsSerice: ContactUsService) { }

  ngOnInit(): void {
    this.showEmptyFieldsError = false;
  }

  onSendContact() {
    this.showEmptyFieldsError = false;
    this.contactMessage = undefined;
    // console.log(this.contactUs);
    if (this.contactUs.name !== '' && this.contactUs.email !== '' && this.contactUs.subject !== '' && this.contactUs.message !== '') {
      this.contactUsSerice.sendContactUsEmail(
        this.contactUs.file,
        this.contactUs.name,
        this.contactUs.email,
        this.contactUs.subject,
        this.contactUs.message
      ).subscribe(data => {
        // console.log(data);
        if (data['success'] == true) {
          this.contactMessage = 'Sent successfully!';
          this.contactUs = {
            name : '',
            email: '',
            subject: '',
            message: '',
            file: File
          };
        } else {
          this.contactMessage = data['result']
        }
      }, (err: any) => {
        this.contactMessage = 'Something went wrong!'
      })
    } else {
      this.showEmptyFieldsError = true;
    }
  }

  onFileSelected(event) {
    // console.log(event.target.files[0]);
    this.contactUs.file  = event.target.files[0];
  }

}
